import { gql } from "@/gql";

export const GET_CUSTOMER_CONSENTS = gql(`
  query GetCustomerConsents($customerId: String!) {
    getCustomerConsents(customerId: $customerId) {
      id
      consentType
      consentChannel
      isGranted
      isActive
      grantedAt
      revokedAt
      expiresAt
      source
      method
      legalBasis
    }
  }
`);

export const GET_CUSTOMER_CONSENT_HISTORY = gql(`
  query GetCustomerConsentHistory($customerId: String!) {
    getCustomerConsentHistory(customerId: $customerId) {
      id
      customerId
      consentType
      action
      source
      method
      ipAddress
      userAgent
    }
  }
`);

export const HAS_CONSENT = gql(`
  query HasConsent(
    $customerId: String!
    $consentType: ConsentType!
    $consentChannel: ConsentChannel!
  ) {
    hasConsent(
      customerId: $customerId
      consentType: $consentType
      consentChannel: $consentChannel
    )
  }
`);

export const UPDATE_CONSENT = gql(`
  mutation UpdateConsent($input: UpdateConsentInput!) {
    updateConsent(input: $input) {
      success
      error
      consent {
        id
        customerId
        consentType
        consentChannel
        isGranted
        grantedAt
        revokedAt
        source
        method
        ipAddress
        userAgent
        consentText
        legalBasis
        expiresAt
        isActive
        createdAt
        updatedAt
      }
    }
  }
`);

// Simple marketing consent mutation
export const UPDATE_CUSTOMER_MARKETING_CONSENT = gql(`
  mutation UpdateCustomerMarketingConsent(
    $customerId: String!
    $hasMarketingConsent: Boolean!
  ) {
    updateCustomerMarketingConsent(
      customerId: $customerId
      hasMarketingConsent: $hasMarketingConsent
    )
  }
`);
